import { createEffect, sample, type Event } from 'effector';
import { createGate } from 'effector-react';
import * as Zod from 'zod';
import i18n from '@shared/config/i18n';
import { createForm } from '@unicorn/effector-form';

export type Form = {
  email: string;
};

export type ConfirmHandler = Parameters<Event<Form['email']>['watch']>[0];

export const form = createForm<Form>({
  initialValues: {
    email: '',
  },
  validationSchema: Zod.object({
    email: Zod.union([
      Zod.string().email(i18n.t('incorrectEmail')),
      Zod.literal(''),
    ]).refine((email) => !!email, {
      message: i18n.t('thisIsRequiredField'),
    }),
  }),
});

export const Gate = createGate<{
  isOpen: boolean;
  onConfirm: ConfirmHandler;
}>();

const fxConfirm = createEffect<
  {
    onConfirm: ConfirmHandler;
    email: Form['email'];
  },
  void,
  Error
>(({ onConfirm, email }) => onConfirm(email));

/** После сабмита email передается в onConfirm */
sample({
  clock: form.submitted,
  source: Gate.state,
  filter: ({ isOpen }) => isOpen,
  fn: ({ onConfirm }, { email }) => ({ onConfirm, email }),
  target: fxConfirm,
});

/** При открытии модалки сбрасывается форма */
sample({
  clock: Gate.state,
  filter: ({ isOpen }) => isOpen,
  target: form.reset,
});
